<template>
  <div class="nav-monitor-wrap">
    <BMap @loaded="bmapLoaded" />
    <!-- <el-input
      v-model="coord"
      style="position: absolute;right:10px;top: 10px;z-index: 10;width: 200px;"
      @change="inputChange"
    ></el-input> -->
    <slot></slot>
  </div>
</template>

<script>
import BMap from '@/components/bmapGL';

import {
  makeView,
  makeHeatGridLayer,
  toPointGeoJson,
  to,
  toCoordinate,
  toBmapCoordinate
} from '@/utils/bmapUtil';

export default {
  components: { BMap },
  data() {
    return {
      bmap: null,
      view: null,
      heatGridLayer: null,
      points: [],
      interval: null,
      pause: 2000,
      coord: ''
    };
  },
  methods: {
    bmapLoaded(bmap) {
      this.bmap = bmap;
      // this.registeBmapClick();
      this.$nextTick(() => {
        const point = new BMapGL.Point(116.387456, 39.925406);
        this.bmap.centerAndZoom(point, 12);
        this.view = makeView(bmap);
        this.heatGridLayer = makeHeatGridLayer({ view: this.view });
        this.$emit('loaded', this);
      });
    },
    async addPoint(lng, lat, count) {
      if (!lng && !lat) return;
      const points = await toBmapCoordinate({ coordinates: [[lng, lat]] });
      if (!points.length) return;
      const geoJson = toPointGeoJson(points[0], count);
      const flag = this.points.some(e => JSON.stringify(e) === JSON.stringify(geoJson));
      if (flag) return;
      this.points.push(geoJson);
    },
    inputChange() {
      this.locateTo(this.coord.split(','));
    },
    registeBmapClick() {
      this.bmap.addEventListener('click', e => {
        this.addPoint(e.latlng.lng, e.latlng.lat, 100);
      });
    },
    locateTo({ center, zoom = 15, tilt = 40 }) {
      return to(this.bmap, {
        center: toCoordinate(center),
        zoom,
        tilt
      });
    },
    resetHeatGridData(points) {
      if (this.points !== points) this.points.splice(0, Infinity, ...points);
      this.heatGridLayer.setData(points);
    },
    updateInterval(pause) {
      pause = pause || this.pause;
      clearInterval(this.interval);
      let prev = 0;
      const cb = () => {
        if (this.points.length === prev) return;
        prev = this.points.length;
        this.resetHeatGridData(this.points);
      };
      cb();
      this.interval = setInterval(cb, pause);
    }
  },
  created() {
    this.updateInterval();
  }
};
</script>

<style lang="scss">
.nav-monitor-wrap {
  width: 100%;
  height: calc(100% - 35px);
  position: relative;
}
</style>
